<template>
     <div class="hd_banner" v-loading="loading">
            <el-carousel :autoplay="true" :loop="true">
                <el-carousel-item v-for="(item, index) in banner_list" :key="index">
                    <div class="banner_img">
                        <!-- <img src="@/assets/img/index/home/banners.jpg" alt=""> -->
                         <img :src="item.image" alt=""  @click="handle_path(item)">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    props:{
        id:{
            type: Number,
             default: 0
		},
    },
    name: "homes",
    data() {
        return {
            loading: false,
            banner_list:[]
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_banner()
    },
    methods: {
        get_banner(){
            this.loading=true
            this.$api("getBanner", {
                position:this.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('bannersid:'+this.id,res)
                if (res.code == 1) {
                   this.banner_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_path(item){
            if(item.url){
                window.open(item.url)
            }
        },


    },

}
</script>
<style scoped lang="less">
 .hd_banner {
        width: 100%;
        // width: 1920px;
        height: 260px;

        /deep/.el-carousel {
            height: 260px;

            .el-carousel__container {
                height: 100%;

                .banner_img {
                    width: 100%;
                    height: 100%;
                    img {
                        width: 100%;
                        height: 100%;
                    }

                }
            }

            .el-carousel__indicators {
                // position: relative;
                z-index: 101;
                // margin-top: 20px;
                // bottom: -5px;

                .el-carousel__indicator {
                    .el-carousel__button {
                        width: 10px;
                        height: 10px;
                        background: #FFFFFF;
                        border-radius: 50%;
                    }
                }

                .is-active {
                    .el-carousel__button {
                        width: 40px;
                        height: 10px;
                        background: #377CFD;
                        border-radius: 5px 5px 5px 5px;
                        // .opacity
                        opacity: 1;
                    }
                }
            }
        }
    }
</style>